// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2gYsp","large":"styles_large__3Y0my"};